import React, { RefObject } from "react";
import { Flex } from "@chakra-ui/react";
import CustomIcon from "../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  containerRef: RefObject<HTMLDivElement>;
  isVisible: boolean;
}

// 원형 "맨 위로" 버튼 — 목록 끝(PathPickScrollToTopButton)과 모바일 페이지네이션 가운데 칸 공용.
// 스크롤 주체가 window가 아니라 패스픽 페이지의 overflow Box라서 containerRef를 받아 직접 올린다.
// 감출 때도 자리는 지킨다 — 보임 여부로 DOM을 넣고 빼면 주변 배치가 흔들린다.
function PathPickScrollToTopCircleButton({ containerRef, isVisible }: Props) {
  const { t } = useI18nHelper();

  return (
    <Flex
      as={"button"}
      type={"button"}
      aria-label={t("path_pick:search_products.product_list.scroll_to_top")}
      aria-hidden={!isVisible}
      tabIndex={isVisible ? undefined : -1}
      onClick={() =>
        containerRef.current?.scrollTo({ top: 0, behavior: "smooth" })
      }
      width={"36px"}
      height={"36px"}
      flexShrink={0}
      borderRadius={"full"}
      justifyContent={"center"}
      alignItems={"center"}
      background={"#FFFFFF"}
      border={"0.5px solid #D4D4D1"}
      boxShadow={"0px 1px 4px rgba(0, 0, 0, 0.08)"}
      opacity={isVisible ? 1 : 0}
      pointerEvents={isVisible ? "auto" : "none"}
      transition={"opacity 0.2s ease"}
      _hover={{ background: "#F7F9FA" }}
    >
      <CustomIcon src={"chevron-up"} width={16} height={16} />
    </Flex>
  );
}

export default PathPickScrollToTopCircleButton;
